import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/user/report.vue'
wx.createPage(MiniProgramPage)